'use strict'

# Remember to call Groupon.Performance.pageReady() when the page is completely
# loaded. This will send performance data to Optimize.
#
# More context is available at:
# https://pages.github.groupondev.com/InteractionTier/framework/optimize.html
#
# Sample code:
# $(window).on 'load', ->
#   Groupon.Performance.pageReady()

require '../common/moment_init'
require '../common/backbone_init'

SearchWidget = require('../../modules/search_getaways/frontend/search_widget.coffee')
CityPage = require('../../modules/getaways_seo/frontend/city_page.coffee')
Metrics = require('../../modules/common/frontend/metrics.coffee')
applyGIGFixes = require('./js/gig_v8_hacks')

$(document).ready ->
  CityPage.init()
  SearchWidget.init()

$(window).on 'load', ->
  Metrics.init()
  applyGIGFixes()
